// removed by extract-text-webpack-plugin
module.exports = {"groupTitle":"CentricUI__menus__CardFieldContextMenuItems__groupTitle","fieldTitle":"CentricUI__menus__CardFieldContextMenuItems__fieldTitle","fieldLabel":"CentricUI__menus__CardFieldContextMenuItems__fieldLabel","fieldName":"CentricUI__menus__CardFieldContextMenuItems__fieldName","groupTitleMenuItem":"CentricUI__menus__CardFieldContextMenuItems__groupTitleMenuItem"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/contextMenus/menus/CardFieldContextMenuItems.css
// module id = 866
// module chunks = 10